import { Node, Sprite, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import BaseBanner from './BaseBanner';
import OuterLobbyUIController from '../../../Controller/UIController/OuterLobbyUIController';
import RemoteLoader from '../../../../../common/scripts/Toolkit/Helper/Loading/RemoteLoader';
import { EnterTableOption } from '../../../../../tableEngine/Script/Game/Data/Model/HallModel';
import { FeatureActivityEventName } from '../../../Data/Config/FeatureActivityConfig';
import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';

const { ccclass, property } = _decorator;

@ccclass('ImageBanner')
export default class ImageBanner extends BaseBanner {
    @property(Sprite)
    private readonly image: Sprite = null;

    private _outerLobbyUIController: OuterLobbyUIController = null;

    private get outerLobbyUIController() {
        if (!this._outerLobbyUIController) {
            this._outerLobbyUIController = Lobby.scene.currentScene.getComponentInChildren(OuterLobbyUIController);
        }
        return this._outerLobbyUIController;
    }

    public display({ ImageURL, OnClick }: DataType.Hall.BannerData): void {
        if (ImageURL) {
            RemoteLoader.loadSpriteFrame(ImageURL).then((spriteFrame) => {
                this.image.spriteFrame = spriteFrame;
            });
            if (OnClick) {
                this.node.on(Node.EventType.TOUCH_END, () => {
                    if (!this.interactable) {
                        return;
                    }
                    const { HallID = '', GameID = '', TableID = -1, URL = '' } = OnClick;
                    if (URL) {
                        window.open(URL, '_blank');
                        Lobby.activity.send(FeatureActivityEventName.ClickBanner, { URL });
                    } else {
                        const enterTableOption: Partial<EnterTableOption> = {};

                        if (TableID) {
                            enterTableOption.tableID = TableID;
                        }
                        Lobby.activity.send(FeatureActivityEventName.ClickBanner, { HallID, GameID });
                        this.outerLobbyUIController.joinTable(enterTableOption);
                    }
                });
            }
        }
    }

    protected shouldTurningBlocked() {
        return false;
    }
    protected onCanPlayChanged(): void {}
    protected onInteractableChanged(): void {}
}
